import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Sigma = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, Object.assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 16 16"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.713 11.48l.694-1.48h.594l-1 6h-15v-1.16l5.18-6.113-5.18-5.18V0h15.313l.688 4h-.537l-.293-.607C14.62 2.247 14.205 2 13.002 2H2.658l5.517 5.516-4.647 5.483h8.474c1.813 0 2.291-.65 2.713-1.52z"
  }));
});
Sigma.displayName = 'Sigma';
export var SigmaDimensions = {
  height: 16,
  width: 16
};